import { render, staticRenderFns } from "./editBrand.vue?vue&type=template&id=3c9b4a6b&scoped=true&"
import script from "./editBrand.vue?vue&type=script&lang=js&"
export * from "./editBrand.vue?vue&type=script&lang=js&"
import style0 from "./editBrand.vue?vue&type=style&index=0&id=3c9b4a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b4a6b",
  null
  
)

component.options.__file = "editBrand.vue"
export default component.exports